<template>
  <div class="contact--profile">
    <div class="contact--info">
      <div class="contact-actions" style="justify-content: center">
        <svg
          id="delete"
          class="mr-4"
          v-if="isAdmin"
          v-tooltip="$t('DELETE_CONTACT.BUTTON_LABEL')"
          @click="toggleDeleteModal"
          style="cursor: pointer;"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.96847 5.72761L2.9687 5.72759L5.0087 5.52759L5.01041 5.52742C10.285 4.99203 15.6389 5.19933 21.0211 5.72759L21.0214 5.72761C21.1525 5.74041 21.2559 5.86227 21.2423 6.00143L21.2422 6.00142L21.2414 6.01163C21.2322 6.13159 21.1283 6.22998 20.9999 6.22998H20.9998H20.9997H20.9996H20.9994H20.9993H20.9992H20.9991H20.999H20.9989H20.9987H20.9986H20.9985H20.9984H20.9983H20.9981H20.998H20.9979H20.9978H20.9976H20.9975H20.9974H20.9973H20.9972H20.997H20.9969H20.9968H20.9967H20.9965H20.9964H20.9963H20.9962H20.9961H20.9959H20.9958H20.9957H20.9956H20.9954H20.9953H20.9952H20.9951H20.9949H20.9948H20.9947H20.9945H20.9944H20.9943H20.9942H20.994H20.9939H20.9938H20.9937H20.9935H20.9934H20.9933H20.9931H20.993H20.9929H20.9927H20.9926H20.9925H20.9924H20.9922H20.9921H20.992H20.9918H20.9917H20.9916H20.9914H20.9913H20.9912H20.991H20.9909H20.9908H20.9906H20.9905H20.9904H20.9902H20.9901H20.99H20.9898H20.9897H20.9896H20.9894H20.9893H20.9892H20.989H20.9889H20.9888H20.9886H20.9885H20.9884H20.9882H20.9881H20.988H20.9878H20.9877H20.9875H20.9874H20.9873H20.9871H20.987H20.9869H20.9867H20.9866H20.9864H20.9863H20.9862H20.986H20.9859H20.9857H20.9856H20.9855H20.9853H20.9852H20.985H20.9849H20.9848H20.9846H20.9845H20.9843H20.9842H20.9841H20.9839H20.9838H20.9836H20.9835H20.9833H20.9832H20.9831H20.9829H20.9828H20.9826H20.9825H20.9823H20.9822H20.982H20.9819H20.9818H20.9816H20.9815H20.9813H20.9812H20.981H20.9809H20.9807H20.9806H20.9805H20.9803H20.9802H20.98H20.9799H20.9797H20.9796H20.9794H20.9793H20.9791H20.979H20.9788H20.9787H20.9785H20.9784H20.9782H20.9781H20.9779H20.9778H20.9776H20.9775H20.9774H20.9772H20.9771H20.9769H20.9768H20.9766H20.9765H20.9763H20.9762H20.976H20.9759H20.9757H20.9755H20.9754H20.9752H20.9751H20.9749H20.9748H20.9746H20.9745H20.9743H20.9742H20.974H20.9739H20.9737H20.9736H20.9734H20.9733H20.9731H20.973H20.9728H20.9727H20.9725H20.9723H20.9722H20.972H20.9719H20.9717H20.9716H20.9714H20.9713H20.9711H20.9709H20.9708H20.9706H20.9705H20.9703H20.9702H20.97H20.9699H20.9697H20.9695H20.9694H20.9692H20.9691H20.9689H20.9688H20.9686H20.9684H20.9683H20.9681H20.968H20.9678H20.9677H20.9675H20.9673H20.9672H20.967H20.9669H20.9667H20.9665H20.9664H20.9662H20.9661H20.9659H20.9658H20.9656H20.9654H20.9653H20.9651H20.965H20.9648H20.9646H20.9645H20.9643H20.9641H20.964H20.9638H20.9637H20.9635H20.9633H20.9632H20.963H20.9629H20.9627H20.9625H20.9624H20.9622H20.962H20.9619H20.9617H20.9616H20.9614H20.9612H20.9611H20.9609H20.9607H20.9606H20.9604H20.9603H20.9601H20.9599H20.9598H20.9596H20.9594H20.9593H20.9591H20.9589H20.9588H20.9586H20.9585H20.9583H20.9581H20.958H20.9578H20.9576H20.9575H20.9573H20.9571H20.957H20.9568H20.9566H20.9565H20.9563H20.9561H20.956H20.9558H20.9556H20.9555H20.9553H20.9551H20.955H20.9548H20.9546H20.9545H20.9543H20.9541H20.954H20.9538H20.9536H20.9535H20.9533H20.9531H20.953H20.9528H20.9526H20.9525H20.9523H20.9521H20.952H20.9518H20.9516H20.9515H20.9513H20.9511H20.951H20.9508H20.9506H20.9504H20.9503H20.9501H20.9499H20.9498H20.9496H20.9494H20.9493H20.9491H20.9489H20.9488H20.9486H20.9484H20.9482H20.9481H20.9479H20.9477H20.9476H20.9474H20.9472H20.9471H20.9469H20.9467H20.9465H20.9464H20.9462H20.946H20.9459H20.9457H20.9455H20.9453H20.9452H20.945H20.9449C15.6444 5.69995 10.3369 5.49881 5.07031 6.03244C5.07004 6.03247 5.06977 6.0325 5.0695 6.03252L3.03251 6.23223C3.03234 6.23224 3.03217 6.23226 3.032 6.23228C2.88184 6.24631 2.76097 6.14225 2.74766 6.00257C2.73369 5.85584 2.83404 5.74073 2.96847 5.72761Z"
            stroke="#483A9D"
          />
          <path
            d="M8.46812 5.21961C8.46811 5.21961 8.4681 5.21961 8.46809 5.21961L8.4681 5.21957L8.4562 5.21748C8.32208 5.19401 8.23119 5.05809 8.25252 4.93619L8.2531 4.93281L8.4731 3.62281L8.47321 3.6222C8.5566 3.12186 8.63936 2.68383 8.90991 2.34957C9.15261 2.04971 9.62364 1.75 10.69 1.75H13.31C14.3761 1.75 14.8502 2.05891 15.0951 2.36644C15.3677 2.70887 15.4485 3.1516 15.5265 3.63046L15.5265 3.63046L15.527 3.63343L15.747 4.93343L15.7471 4.93415C15.7712 5.07527 15.6716 5.19816 15.5558 5.21553L15.5558 5.21543L15.5459 5.21713C15.4047 5.24123 15.2818 5.14164 15.2645 5.02583L15.2646 5.02582L15.263 5.01657L15.0433 3.71859L15.041 3.70407C15.0086 3.50231 14.9764 3.30232 14.929 3.13454C14.8786 2.95627 14.7964 2.75644 14.6263 2.59311C14.4535 2.42715 14.243 2.34919 14.0338 2.3091C13.8309 2.27019 13.5908 2.26 13.32 2.26H10.7C10.4321 2.26 10.1944 2.26819 9.99489 2.30338C9.78973 2.33956 9.57759 2.41193 9.40208 2.57621C9.22894 2.73827 9.14632 2.939 9.09567 3.11616C9.04882 3.28006 9.01559 3.47745 8.98163 3.67921C8.98019 3.68776 8.97875 3.69633 8.9773 3.7049L8.74766 5.00289L8.74761 5.00288L8.74646 5.00996C8.72663 5.13222 8.62054 5.22 8.50001 5.22L8.47754 5.2199L8.46812 5.21961Z"
            stroke="#483A9D"
          />
          <path
            d="M4.89886 9.15787L4.89888 9.15787L4.89857 9.15359C4.88946 9.02915 4.9904 8.9029 5.13023 8.88927C5.27958 8.88535 5.39059 8.9922 5.40111 9.12499L6.05094 19.1923L6.05092 19.1923L6.0512 19.1962L6.05298 19.2207C6.07909 19.5818 6.10405 19.927 6.16156 20.2232C6.22142 20.5315 6.32557 20.8412 6.54777 21.1005C6.99613 21.6236 7.75483 21.7501 8.7899 21.7501H15.2099C16.249 21.7501 17.0109 21.6239 17.4595 21.1005C17.6823 20.8405 17.7858 20.5299 17.8443 20.221C17.9008 19.9225 17.9237 19.5746 17.9476 19.211L17.9488 19.1929L17.9489 19.1923L18.5987 9.12503C18.609 8.9957 18.7263 8.88545 18.8695 8.88925C19.0128 8.90286 19.1106 9.02293 19.1012 9.15445L19.1009 9.15787L18.4511 19.2249C18.4511 19.2254 18.4511 19.2259 18.451 19.2264C18.394 20.0351 18.3293 20.7564 17.9408 21.299C17.5852 21.7959 16.866 22.2501 15.2099 22.2501H8.7899C7.13376 22.2501 6.41464 21.7959 6.05896 21.299C5.67052 20.7564 5.60581 20.0351 5.54876 19.2264C5.54873 19.2259 5.5487 19.2254 5.54866 19.2249L4.89886 9.15787Z"
            stroke="#483A9D"
          />
          <path
            d="M13.6601 16.75H10.3301C10.1962 16.75 10.0801 16.6339 10.0801 16.5C10.0801 16.3661 10.1962 16.25 10.3301 16.25H13.6601C13.7939 16.25 13.9101 16.3661 13.9101 16.5C13.9101 16.6339 13.7939 16.75 13.6601 16.75Z"
            fill="#483A9D"
            stroke="#483A9D"
          />
          <path
            d="M14.5 12.75H9.5C9.36614 12.75 9.25 12.6339 9.25 12.5C9.25 12.3661 9.36614 12.25 9.5 12.25H14.5C14.6339 12.25 14.75 12.3661 14.75 12.5C14.75 12.6339 14.6339 12.75 14.5 12.75Z"
            fill="#483A9D"
            stroke="#483A9D"
          />
        </svg>

<!--        <svg
          class="mr-4"
          v-if="isAdmin"
          v-tooltip="$t('CONTACT_PANEL.MERGE_CONTACT')"
          @click="openMergeModal"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14Z"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 6C2.89543 6 2 5.10457 2 4C2 2.89543 2.89543 2 4 2C5.10457 2 6 2.89543 6 4C6 5.10457 5.10457 6 4 6Z"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4 22C2.89543 22 2 21.1046 2 20C2 18.8954 2.89543 18 4 18C5.10457 18 6 18.8954 6 20C6 21.1046 5.10457 22 4 22Z"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M20 12L6 12"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 4H10C12 4 13 5 13 7V17C13 19 12 20 10 20H6"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19 14L20.8373 12.3535C21.0542 12.1591 21.0542 11.8409 20.8373 11.6465L19 10"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>-->
        <a
          v-if="!isAdmin"
          :href="`${editUrl}`"
          target="_blank"
          rel="noreferrer noopener nofollow"
        >
            <svg
          id="edit"
          class="mr-4"
          v-tooltip="$t('EDIT_CONTACT.BUTTON_LABEL')"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.2946 18.5578L4.29289 18.5562C3.90204 18.1879 3.69216 17.6108 3.76681 16.9463C3.76682 16.9462 3.76684 16.9461 3.76685 16.9459L4.13673 13.7071C4.13673 13.707 4.13674 13.707 4.13674 13.7069C4.13675 13.7069 4.13675 13.7068 4.13676 13.7068C4.16421 13.4679 4.25484 13.1654 4.39347 12.8669C4.53247 12.5676 4.70341 12.3075 4.86758 12.1395L4.86763 12.1396L4.87344 12.1334L13.0834 3.44342L13.0834 3.44341C14.0543 2.41577 14.9847 1.95232 15.8691 1.92735C16.7536 1.90238 17.7089 2.31263 18.7366 3.28351C19.7643 4.25432 20.2277 5.18473 20.2527 6.06916C20.2777 6.95365 19.8674 7.90897 18.8965 8.93669L10.6865 17.6267L10.6845 17.6289C10.3392 17.9988 9.65904 18.3647 9.1591 18.4466L9.1558 18.4472L5.9625 18.9926C5.88513 18.9975 5.82527 19.0027 5.77296 19.0072C5.68953 19.0145 5.62533 19.0201 5.53999 19.0201C5.04247 19.0201 4.6008 18.849 4.2946 18.5578ZM13.4465 3.76674L13.4463 3.76688L5.23792 12.4652C5.23762 12.4655 5.23733 12.4658 5.23703 12.4662C5.08276 12.6285 4.94835 12.8619 4.85189 13.0686C4.75434 13.2776 4.66435 13.5266 4.63468 13.7417L4.63454 13.7417L4.63322 13.7533L4.26362 16.9899C4.26354 16.9905 4.26347 16.9911 4.26339 16.9918C4.2111 17.4267 4.30841 17.8735 4.63667 18.1836C4.96741 18.4959 5.41493 18.558 5.83489 18.4944L5.8349 18.4945L5.84417 18.4929L9.06417 17.9429L9.06494 17.9428C9.28635 17.9046 9.53348 17.7991 9.73561 17.6904C9.93802 17.5815 10.16 17.4345 10.3121 17.2749L10.3134 17.2734L18.5234 8.58342L18.5244 8.58239C19.1594 7.90648 19.6904 7.16043 19.7428 6.29271C19.7969 5.39816 19.3382 4.53411 18.3845 3.63768C17.5397 2.82521 16.7322 2.41005 15.93 2.41005C14.94 2.41005 14.1433 3.02891 13.4465 3.76674Z"
            stroke="#483A9D"
          />
          <path
            d="M17.381 9.95745L17.3814 9.95749C17.5099 9.97003 17.6117 10.0873 17.603 10.2229C17.5817 10.3519 17.4645 10.4498 17.3399 10.4498H17.3398H17.3397H17.3396H17.3395H17.3394H17.3392H17.3391H17.339H17.3389H17.3388H17.3386H17.3385H17.3384H17.3383H17.3382H17.338H17.3379H17.3378H17.3377H17.3376H17.3374H17.3373H17.3372H17.3371H17.3369H17.3368H17.3367H17.3366H17.3365H17.3363H17.3362H17.3361H17.336H17.3358H17.3357H17.3356H17.3355H17.3353H17.3352H17.3351H17.335H17.3348H17.3347H17.3346H17.3345H17.3343H17.3342H17.3341H17.3339H17.3338H17.3337H17.3336H17.3334H17.3333H17.3332H17.3331H17.3329H17.3328H17.3327H17.3325H17.3324H17.3323H17.3321H17.332H17.3319H17.3318H17.3316H17.3315H17.3314H17.3312H17.3311H17.331H17.3308H17.3307H17.3306H17.3304H17.3303H17.3302H17.33H17.3299H17.3298H17.3297H17.3295H17.3294H17.3293H17.3291H17.329H17.3289H17.3287H17.3286H17.3284H17.3283H17.3282H17.328H17.3279H17.3278H17.3276H17.3275H17.3274H17.3272H17.3271H17.327H17.3268H17.3267H17.3266H17.3264H17.3263H17.3261H17.326H17.3259H17.3257H17.3256H17.3255H17.3253H17.3252H17.325H17.3249H17.3248H17.3246H17.3245H17.3244H17.3242H17.3241H17.3239H17.3238H17.3237H17.3235H17.3234H17.3232H17.3231H17.323H17.3228H17.3227H17.3225H17.3224H17.3223H17.3221H17.322H17.3218H17.3217H17.3216H17.3214H17.3213H17.3211H17.321H17.3209H17.3207H17.3206H17.3204H17.3203H17.3202H17.32H17.3199H17.3197H17.3196H17.3194H17.3193H17.3192H17.319H17.3189H17.3187H17.3186H17.3185H17.3183H17.3182H17.318H17.3179H17.3177H17.3176H17.3175H17.3173H17.3172H17.317H17.3169H17.3167H17.3166H17.3164H17.3163H17.3162H17.316H17.3159H17.3157H17.3156H17.3154H17.3153H17.3152H17.315H17.3149H17.3147H17.3146H17.3144H17.3143H17.3141H17.314H17.3138H17.3137H17.3136H17.3134H17.3133H17.3131H17.313H17.3128H17.3127H17.3125H17.3124H17.3123H17.3121H17.312H17.3118H17.3117H17.3115H17.3114H17.3112H17.3111H17.3109H17.3108H17.3107H17.3105H17.3104H17.3102H17.3101H17.3099H17.3098H17.3096H17.3095H17.3093H17.3092H17.309H17.3089H17.3088H17.3086H17.3085H17.3083H17.3082H17.308H17.3079H17.3077H17.3076H17.3074H17.3073H17.3071H17.307H17.3069H17.3067H17.3066H17.3064H17.3063H17.3061H17.306H17.3058H17.3057H17.3055H17.3054H17.3052H17.3051H17.3049H17.3048H17.3047H17.3045H17.3044H17.3042H17.3041H17.3039H17.3038H17.3036H17.3035H17.3033H17.3032H17.303H17.3029H17.3028H17.3026H17.3025H17.3023H17.3022H17.302H17.3019H17.3017H17.3016H17.3014H17.3013H17.3011H17.301H17.3008H17.3007H17.3006H17.3004H17.3003H17.3001H17.3H17.2998H17.2997H17.2995H17.2994H17.2992H17.2991H17.299H17.2988H17.2987H17.2985H17.2984H17.2982H17.2981H17.2979H17.2978H17.2976H17.2975H17.2974H17.2972H17.2971H17.2969H17.2968H17.2966H17.2965H17.2963H17.2962H17.296H17.2959H17.2958H17.2956H17.2955H17.2953H17.2952C14.4136 10.1526 12.0992 7.96071 11.6545 5.0959C11.6356 4.96146 11.7253 4.8313 11.8681 4.8038C12.0022 4.78727 12.1309 4.87817 12.1567 5.02159C12.5734 7.6634 14.7145 9.69517 17.381 9.95745Z"
            stroke="#483A9D"
          />
          <path
            d="M21 22.25H3C2.86614 22.25 2.75 22.1339 2.75 22C2.75 21.8661 2.86614 21.75 3 21.75H21C21.1339 21.75 21.25 21.8661 21.25 22C21.25 22.1339 21.1339 22.25 21 22.25Z"
            fill="#483A9D"
            stroke="#483A9D"
          />
        </svg>
        </a>
        <svg
          v-if="isAdmin"
          id="edit"
          class="mr-4"
          v-tooltip="$t('EDIT_CONTACT.BUTTON_LABEL')"
          @click="toggleEditModal"
          style="cursor: pointer;"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.2946 18.5578L4.29289 18.5562C3.90204 18.1879 3.69216 17.6108 3.76681 16.9463C3.76682 16.9462 3.76684 16.9461 3.76685 16.9459L4.13673 13.7071C4.13673 13.707 4.13674 13.707 4.13674 13.7069C4.13675 13.7069 4.13675 13.7068 4.13676 13.7068C4.16421 13.4679 4.25484 13.1654 4.39347 12.8669C4.53247 12.5676 4.70341 12.3075 4.86758 12.1395L4.86763 12.1396L4.87344 12.1334L13.0834 3.44342L13.0834 3.44341C14.0543 2.41577 14.9847 1.95232 15.8691 1.92735C16.7536 1.90238 17.7089 2.31263 18.7366 3.28351C19.7643 4.25432 20.2277 5.18473 20.2527 6.06916C20.2777 6.95365 19.8674 7.90897 18.8965 8.93669L10.6865 17.6267L10.6845 17.6289C10.3392 17.9988 9.65904 18.3647 9.1591 18.4466L9.1558 18.4472L5.9625 18.9926C5.88513 18.9975 5.82527 19.0027 5.77296 19.0072C5.68953 19.0145 5.62533 19.0201 5.53999 19.0201C5.04247 19.0201 4.6008 18.849 4.2946 18.5578ZM13.4465 3.76674L13.4463 3.76688L5.23792 12.4652C5.23762 12.4655 5.23733 12.4658 5.23703 12.4662C5.08276 12.6285 4.94835 12.8619 4.85189 13.0686C4.75434 13.2776 4.66435 13.5266 4.63468 13.7417L4.63454 13.7417L4.63322 13.7533L4.26362 16.9899C4.26354 16.9905 4.26347 16.9911 4.26339 16.9918C4.2111 17.4267 4.30841 17.8735 4.63667 18.1836C4.96741 18.4959 5.41493 18.558 5.83489 18.4944L5.8349 18.4945L5.84417 18.4929L9.06417 17.9429L9.06494 17.9428C9.28635 17.9046 9.53348 17.7991 9.73561 17.6904C9.93802 17.5815 10.16 17.4345 10.3121 17.2749L10.3134 17.2734L18.5234 8.58342L18.5244 8.58239C19.1594 7.90648 19.6904 7.16043 19.7428 6.29271C19.7969 5.39816 19.3382 4.53411 18.3845 3.63768C17.5397 2.82521 16.7322 2.41005 15.93 2.41005C14.94 2.41005 14.1433 3.02891 13.4465 3.76674Z"
            stroke="#483A9D"
          />
          <path
            d="M17.381 9.95745L17.3814 9.95749C17.5099 9.97003 17.6117 10.0873 17.603 10.2229C17.5817 10.3519 17.4645 10.4498 17.3399 10.4498H17.3398H17.3397H17.3396H17.3395H17.3394H17.3392H17.3391H17.339H17.3389H17.3388H17.3386H17.3385H17.3384H17.3383H17.3382H17.338H17.3379H17.3378H17.3377H17.3376H17.3374H17.3373H17.3372H17.3371H17.3369H17.3368H17.3367H17.3366H17.3365H17.3363H17.3362H17.3361H17.336H17.3358H17.3357H17.3356H17.3355H17.3353H17.3352H17.3351H17.335H17.3348H17.3347H17.3346H17.3345H17.3343H17.3342H17.3341H17.3339H17.3338H17.3337H17.3336H17.3334H17.3333H17.3332H17.3331H17.3329H17.3328H17.3327H17.3325H17.3324H17.3323H17.3321H17.332H17.3319H17.3318H17.3316H17.3315H17.3314H17.3312H17.3311H17.331H17.3308H17.3307H17.3306H17.3304H17.3303H17.3302H17.33H17.3299H17.3298H17.3297H17.3295H17.3294H17.3293H17.3291H17.329H17.3289H17.3287H17.3286H17.3284H17.3283H17.3282H17.328H17.3279H17.3278H17.3276H17.3275H17.3274H17.3272H17.3271H17.327H17.3268H17.3267H17.3266H17.3264H17.3263H17.3261H17.326H17.3259H17.3257H17.3256H17.3255H17.3253H17.3252H17.325H17.3249H17.3248H17.3246H17.3245H17.3244H17.3242H17.3241H17.3239H17.3238H17.3237H17.3235H17.3234H17.3232H17.3231H17.323H17.3228H17.3227H17.3225H17.3224H17.3223H17.3221H17.322H17.3218H17.3217H17.3216H17.3214H17.3213H17.3211H17.321H17.3209H17.3207H17.3206H17.3204H17.3203H17.3202H17.32H17.3199H17.3197H17.3196H17.3194H17.3193H17.3192H17.319H17.3189H17.3187H17.3186H17.3185H17.3183H17.3182H17.318H17.3179H17.3177H17.3176H17.3175H17.3173H17.3172H17.317H17.3169H17.3167H17.3166H17.3164H17.3163H17.3162H17.316H17.3159H17.3157H17.3156H17.3154H17.3153H17.3152H17.315H17.3149H17.3147H17.3146H17.3144H17.3143H17.3141H17.314H17.3138H17.3137H17.3136H17.3134H17.3133H17.3131H17.313H17.3128H17.3127H17.3125H17.3124H17.3123H17.3121H17.312H17.3118H17.3117H17.3115H17.3114H17.3112H17.3111H17.3109H17.3108H17.3107H17.3105H17.3104H17.3102H17.3101H17.3099H17.3098H17.3096H17.3095H17.3093H17.3092H17.309H17.3089H17.3088H17.3086H17.3085H17.3083H17.3082H17.308H17.3079H17.3077H17.3076H17.3074H17.3073H17.3071H17.307H17.3069H17.3067H17.3066H17.3064H17.3063H17.3061H17.306H17.3058H17.3057H17.3055H17.3054H17.3052H17.3051H17.3049H17.3048H17.3047H17.3045H17.3044H17.3042H17.3041H17.3039H17.3038H17.3036H17.3035H17.3033H17.3032H17.303H17.3029H17.3028H17.3026H17.3025H17.3023H17.3022H17.302H17.3019H17.3017H17.3016H17.3014H17.3013H17.3011H17.301H17.3008H17.3007H17.3006H17.3004H17.3003H17.3001H17.3H17.2998H17.2997H17.2995H17.2994H17.2992H17.2991H17.299H17.2988H17.2987H17.2985H17.2984H17.2982H17.2981H17.2979H17.2978H17.2976H17.2975H17.2974H17.2972H17.2971H17.2969H17.2968H17.2966H17.2965H17.2963H17.2962H17.296H17.2959H17.2958H17.2956H17.2955H17.2953H17.2952C14.4136 10.1526 12.0992 7.96071 11.6545 5.0959C11.6356 4.96146 11.7253 4.8313 11.8681 4.8038C12.0022 4.78727 12.1309 4.87817 12.1567 5.02159C12.5734 7.6634 14.7145 9.69517 17.381 9.95745Z"
            stroke="#483A9D"
          />
          <path
            d="M21 22.25H3C2.86614 22.25 2.75 22.1339 2.75 22C2.75 21.8661 2.86614 21.75 3 21.75H21C21.1339 21.75 21.25 21.8661 21.25 22C21.25 22.1339 21.1339 22.25 21 22.25Z"
            fill="#483A9D"
            stroke="#483A9D"
          />
        </svg>
        <svg
          v-if="!fromPanel"
          id="message"
          class="mr-4"
          v-tooltip="$t('CONTACT_PANEL.NEW_MESSAGE')"
          @click="toggleConversationModal"
          style="cursor: pointer;"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 7.43018V13.4302C22 14.9302 21.5 16.1802 20.62 17.0602C19.75 17.9302 18.5 18.4302 17 18.4302V20.5602C17 21.3602 16.11 21.8402 15.45 21.4002L11 18.4302H8.88C8.96 18.1302 9 17.8202 9 17.5002C9 16.4802 8.61 15.5402 7.97 14.8302C7.25 14.0102 6.18 13.5002 5 13.5002C3.88 13.5002 2.86 13.9602 2.13 14.7102C2.04 14.3102 2 13.8802 2 13.4302V7.43018C2 4.43018 4 2.43018 7 2.43018H17C20 2.43018 22 4.43018 22 7.43018Z"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 17.5C9 17.82 8.96 18.13 8.88 18.43C8.79 18.83 8.63001 19.22 8.42001 19.56C7.73001 20.72 6.46 21.5 5 21.5C3.97 21.5 3.04 21.11 2.34 20.47C2.04 20.21 1.77999 19.9 1.57999 19.56C1.20999 18.96 1 18.25 1 17.5C1 16.42 1.43 15.43 2.13 14.71C2.86 13.96 3.88 13.5 5 13.5C6.18 13.5 7.25 14.01 7.97 14.83C8.61 15.54 9 16.48 9 17.5Z"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.48999 17.48H3.51001"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5 16.02V19.01"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.5 10.5H15.5"
            stroke="#483A9D"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <edit-contact
        v-if="showEditModal"
        :show="showEditModal"
        :contact="contact"
        @cancel="toggleEditModal"
      />
      <new-conversation
        v-if="contact.id"
        :show="showConversationModal"
        :contact="contact"
        @cancel="toggleConversationModal"
      />
      <contact-merge-modal
        v-if="showMergeModal"
        :primary-contact="contact"
        :show="showMergeModal"
        @close="toggleMergeModal"
      />
    </div>
    <woot-delete-modal
      v-if="showDeleteModal"
      :show.sync="showDeleteModal"
      :on-close="closeDelete"
      :on-confirm="confirmDeletion"
      :title="$t('DELETE_CONTACT.CONFIRM.TITLE')"
      :message="$t('DELETE_CONTACT.CONFIRM.MESSAGE')"
      :message-value="confirmDeleteMessage"
      :confirm-text="$t('DELETE_CONTACT.CONFIRM.YES')"
      :reject-text="$t('DELETE_CONTACT.CONFIRM.NO')"
    />
  </div>
</template>
<script>
import { mixin as clickaway } from 'vue-clickaway';

import ContactInfoRow from './ContactInfoRow';
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import SocialIcons from './SocialIcons';

import EditContact from './EditContact';
import NewConversation from './NewConversation';
import ContactMergeModal from 'dashboard/modules/contact/ContactMergeModal';
import alertMixin from 'shared/mixins/alertMixin';
import adminMixin from '../../../../mixins/isAdmin';
import { mapGetters } from 'vuex';
import { getCountryFlag } from 'dashboard/helper/flag';

export default {
  components: {
    ContactInfoRow,
    EditContact,
    Thumbnail,
    SocialIcons,
    NewConversation,
    ContactMergeModal,
  },
  mixins: [alertMixin, adminMixin, clickaway],
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    channelType: {
      type: String,
      default: '',
    },
    showAvatar: {
      type: Boolean,
      default: true,
    },
    fromPanel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showEditModal: false,
      showConversationModal: false,
      showMergeModal: false,
      showDeleteModal: false,
      redirectUrl: '',
    };
  },
  mounted() {
    if (this.contact.cin) {
      this.getRedirectUrl(this.contact.cin);
    }
  },
  computed: {
    ...mapGetters({ uiFlags: 'contacts/getUIFlags' }),
    contactProfileLink() {
      return `/app/accounts/${this.$route.params.accountId}/contacts/${this.contact.id}`;
    },
    additionalAttributes() {
      return this.contact.additional_attributes || {};
    },
    location() {
      const {
        country = '',
        city = '',
        country_code: countryCode,
      } = this.additionalAttributes;
      const cityAndCountry = [city, country].filter(item => !!item).join(', ');

      if (!cityAndCountry) {
        return '';
      }
      return this.findCountryFlag(countryCode, cityAndCountry);
    },
    socialProfiles() {
      const {
        social_profiles: socialProfiles,
        screen_name: twitterScreenName,
      } = this.additionalAttributes;

      return { twitter: twitterScreenName, ...(socialProfiles || {}) };
    },
    // Delete Modal
    confirmDeleteMessage() {
      return ` ${this.contact.name}?`;
    },
    editUrl() {
      return this.redirectUrl ;
    }
  },
  methods: {
    toggleMergeModal() {
      this.showMergeModal = !this.showMergeModal;
    },
    toggleEditModal() {
      this.showEditModal = !this.showEditModal;
    },
    toggleConversationModal() {
      this.showConversationModal = !this.showConversationModal;
    },
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal;
    },
    confirmDeletion() {
      this.deleteContact(this.contact);
      this.closeDelete();
    },
    closeDelete() {
      this.showDeleteModal = false;
      this.showConversationModal = false;
      this.showEditModal = false;
    },
    findCountryFlag(countryCode, cityAndCountry) {
      try {
        const countryFlag = countryCode ? getCountryFlag(countryCode) : '🌎';
        return `${cityAndCountry} ${countryFlag}`;
      } catch (error) {
        return '';
      }
    },
    async deleteContact({ id }) {
      try {
        await this.$store.dispatch('contacts/delete', id);
        this.$emit('delete-contact');
        this.$emit('panel-close');
        this.showAlert(this.$t('DELETE_CONTACT.API.SUCCESS_MESSAGE'));
        if (this.$route.name !== 'contacts_dashboard') {
          this.$router.push({ name: 'contacts_dashboard' });
        }
      } catch (error) {
        this.showAlert(
          error.message
            ? error.message
            : this.$t('DELETE_CONTACT.API.ERROR_MESSAGE')
        );
      }
    },
    openMergeModal() {
      this.toggleMergeModal();
    },
    /* to return the url for edit the client */
    async getRedirectUrl(cin) {
      const { appLogicURL } = window.convergenceConfig;
      const response = await axios.get(`${appLogicURL}/gat/ticketUrl`, {
        params: {
          numero: cin,
        },
      });
      let redirectUrl = response.data.RedirectUrl;
      this.redirectUrl = redirectUrl;
    },
  },
};
</script>

<style scoped lang="scss">
.contact--profile {
  position: relative;
  align-items: flex-start;
  padding: var(--space-normal);

  .user-thumbnail-box {
    margin-right: var(--space-normal);
  }
}

.contact--details {
  margin-top: var(--space-small);
  width: 100%;
}

.contact--info {
  text-align: left;
}

.contact--name-wrap {
  display: flex;
  align-items: center;
  margin-bottom: var(--space-small);
}

.contact--name {
  text-transform: capitalize;
  white-space: normal;
  margin: 0 var(--space-smaller) 0 0;

  a {
    color: var(--color-body);
  }
}

.contact--metadata {
  margin-bottom: var(--space-slab);
}

.contact-actions {
  margin-top: var(--space-small);
}

.contact-actions {
  display: flex;
  align-items: center;
  width: 100%;

  .new-message,
  .edit-contact,
  .merge-contact,
  .delete-contact {
    margin-right: var(--space-small);
  }
}
.merege-summary--card {
  padding: var(--space-normal);
}
.contact--bio {
  word-wrap: break-word;
}

.button--contact-menu {
  position: absolute;
  right: var(--space-normal);
  top: 0;
}
</style>
